jQuery(document).ready(function(){

// To style only selects with the selectpicker class
$('.selectpicker').selectpicker();

	$('li.showoutside').each(function(){
	    let link = $(this).html();
		  $('header .navbar .container .col').append(link);
		  $(this).addClass('d-none d-lg-inline-block');	
	});
	
	$('.navbar .col .nav-link').each(function(){
		  $(this).addClass('d-inline-block d-lg-none');	
	});



	function watchForHover() {
	    var hasHoverClass = false;
	    var container = document.body;
	    var lastTouchTime = 0;

	    function enableHover() {
	        // filter emulated events coming from touch events
	        if (new Date() - lastTouchTime < 500) return;
	        if (hasHoverClass) return;

	        container.className += ' hasHover';
	        hasHoverClass = true;
	    }

	    function disableHover() {
	        if (!hasHoverClass) return;

	        container.className = container.className.replace(' hasHover', '');
	        hasHoverClass = false;
	    }

	    function updateLastTouchTime() {
	        lastTouchTime = new Date();
	    }

	    document.addEventListener('touchstart', updateLastTouchTime, true);
	    document.addEventListener('touchstart', disableHover, true);
	    document.addEventListener('mousemove', enableHover, true);

	    enableHover();
	}

	watchForHover();

});

	



// WEBPACK FOOTER //
// ./js/parts/base.js